export const FETCH_PENDINGRESULTS_OBX_REQUEST = "FETCH_PENDINGRESULTS_OBX_REQUEST";
export const FETCH_PENDINGRESULTS_OBX_SUCCESS = "FETCH_PENDINGRESULTS_OBX_SUCCESS";
export const FETCH_PENDINGRESULTS_OBX_FAILURE = "FETCH_PENDINGRESULTS_OBX_FAILURE";

